import { API_URL_v2 } from "../../env";
import axiosClient, { ResponseSuccessTotal } from "../axiosClient";

const axiosClientList = axiosClient(API_URL_v2);

//Thông tin khách hàng
export interface ICustomer {
  warehouse_id_origin: string
  id: number
  cus_id: string
  cus_name: string
  cus_tel: string
  cus_dms_id_card_no: any
  cus_tax_reg_no_dms: any
  cus_email: any
  cus_gender_name: any
  cus_birth_day: any
  cus_branch_name: any
  cus_route_name: any
  cus_customer_code: any
  cus_total_vehicles: number
}

export interface ICustomerList {
  total: number
  current_page: number
  items: ICustomer[]
}


export const getListCustomerSync = async (

  skip: number = 0, limit: number = 10, keyword?: string, brand?: string,
  gender?: string, ownership_period?: number, vehicle_owned?: number, age_from?: number,
  age_to?: number
) => {
  const path = "api/v1/be/warehouses_elastic"
  const params = {
    'sort[]': 'id,desc', 'status': '1',
    page: skip, limit, keyword, brand,
    gender, ownership_period, vehicle_owned, age_from,
    age_to
  }
  const result: ResponseSuccessTotal<ICustomerList> = await axiosClientList.get(
    path, { params }
  );
  return result;
};



